import { type Route } from './+types/code-of-conduct.ts'

export const meta: Route.MetaFunction = () => {
	return [{ title: 'Code of Conduct | Steel City Backgammon' }]
}

export default function CodeOfConductRoute() {
	return (
		<div className="container py-16">
			<h1 className="text-h1 mb-8">Code of Conduct</h1>
			<div className="prose dark:prose-invert max-w-2xl">
				<p className="text-muted-foreground">Content coming soon.</p>
			</div>
		</div>
	)
}
